import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../Common/Layout";

export default function KataSlipData() {
  const RequiredStar = () => (
    <span style={{ color: "red", marginLeft: "4px" }}>*</span>
  );
  const orderprocess =
    JSON.parse(sessionStorage.getItem("orderprocess")) || {};
 
  const sessionDate = orderprocess.order_date || "";
  const [editIndex, setEditIndex] = useState(null); // Track which entry is being edited


  const vehicleTypes = ["Truck", "Trailer", "Container", "Tempo", "Others"];

  const navigate = useNavigate();
  const { id } = useParams();

  const [entries, setEntries] = useState([]);

  const [truckNos, setTruckNos] = useState([]);

  console.log(entries);


  useEffect(() => {
    const fetchKataSlipEdit = async () => {
      try {
        const token = sessionStorage.getItem("token");

        // ============================================
        // EDIT EXISTING KATA SLIP
        // ============================================
        if (id) {
          const res = await fetch(
            `https://irc.zentelex.com/api/kataslip/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );

          const data = await res.json();

          if (!res.ok || !data.success) {
            throw new Error(
              data.message || "Failed to load Kata Slip",
            );
          }

          const item = data.data;

          setFormData({
            entry_type: item.entry_type || "",
            crdNo: item.crdNo || "",
            cddNo: item.cddNo || "",
            vehicleNo: item.vehicleNo || "",
            product: item.product || "",
            companyName: item.companyName || "",
            variety: item.variety || "",
            cargoType: item.cargoType || "",
            vehicleType: item.vehicleType || "",
            stack: item.stack || "",
            noOfBags: item.noOfBags ?? "",
            miscellaneous: item.miscellaneous || "",
            containerNo: item.containerNo || "",
            dateIn: item.dateIn || "",
            firstWt: item.firstWt ?? "",
            secondWt: item.secondWt ?? "",
            netWt: item.netWt ?? "",
            warehouse: item.warehouse || "",
            labourContractorName:
              item.labourContractorName || "",
            surveyorName: item.surveyorName || "",
            accountType: item.accountType || "own",
          });

          // Keep existing vehicle available
          setTruckNos(
            item.vehicleNo ? [item.vehicleNo] : [],
          );

          return;
        }

        // ============================================
        // ORIGINAL CREATE FLOW
        // ============================================
        const crdNo = orderprocess.crdNo;

        if (!crdNo) {
          toast.error("CRD No not found");
          return;
        }

        const res = await fetch(
          `https://irc.zentelex.com/api/gateentry/trucks/crdNo/${crdNo}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = await res.json();

        if (data.success) {
          setTruckNos(data.truck_nos || []);

          if (data.truck_nos?.length) {
            setFormData((prev) => ({
              ...prev,
              vehicleNo: data.truck_nos[0],
            }));
          }
        } else {
          toast.error("No trucks found for this CRD");
        }
      } catch (err) {
        console.error("Kata Slip load error:", err);
        toast.error(
          err.message || "Failed to load Kata Slip",
        );
      }
    };

    fetchKataSlipEdit();
  }, [id]);

  const [formData, setFormData] = useState({
    entry_type: "",
    vehicleNo: sessionStorage.getItem("truckNo"),
    product: orderprocess.product,
    companyName: orderprocess.company_name,
    variety: orderprocess.variety, // ✅ NEW FIELD
    cargoType: orderprocess.cargo_type, // ✅ ADD THIS

    vehicleType: "",
    stack: "", // ✅ replaced amount
    noOfBags: "",
    miscellaneous: "",
    containerNo: "",
    dateIn: sessionDate, // ✅ auto-fill current date
    firstWt: "",
    secondWt: "",
    netWt: "",
    warehouse: orderprocess.warehouse,
    labourContractorName: orderprocess.labourContractor,
    surveyorName: "",
    accountType: "own", // default
  });

  // Handle input change
  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [id]: value };

      // ✅ Auto-calculate net weight
      const first = parseFloat(updated.firstWt) || 0;
      const second = parseFloat(updated.secondWt) || 0;
      const isOutbound =
        updated.entry_type === "OUTBOUND" ||
        (!!updated.cddNo && !updated.crdNo);

      updated.netWt = isOutbound
        ? second - first
        : first - second;

      return updated;
    });
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const first = parseFloat(formData.firstWt) || 0;
    const second = parseFloat(formData.secondWt) || 0;

    // Net weight calculation
    // INBOUND / CRD: First Wt - Second Wt
    // OUTBOUND / CDD: Second Wt - First Wt
    const isOutbound =
      formData.entry_type === "OUTBOUND" ||
      (!!formData.cddNo && !formData.crdNo);

    const net = isOutbound
      ? second - first
      : first - second;

    // Prevent negative net weight
    if (net < 0) {
      toast.error(
        "Please check First Wt and Second Wt. Net weight cannot be negative.",
        {
          position: "top-right",
          autoClose: 2500,
          theme: "colored",
        },
      );
      return;
    }

    // No. of Bags validation
    if (formData.cargoType !== "Bulk") {
      const bags = Number(formData.noOfBags);

      if (
        !formData.noOfBags ||
        isNaN(bags) ||
        bags <= 0
      ) {
        toast.error("No. of Bags cannot be empty or zero", {
          position: "top-right",
          autoClose: 2000,
          theme: "colored",
        });
        return;
      }
    }

    if (
      !formData.containerNo ||
      formData.containerNo.trim() === ""
    ) {
      toast.error("Container No is required", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
      return;
    }

    const entry = {
      entry_type:
        formData.entry_type ||
        ((formData.cddNo && !formData.crdNo)
          ? "OUTBOUND"
          : "INBOUND"),

      crdNo:
        formData.crdNo ||
        orderprocess.crdNo ||
        null,

      cddNo:
        formData.cddNo ||
        orderprocess.cddNo ||
        null,

      vehicleNo: formData.vehicleNo?.trim(),
      product: formData.product?.trim(),
      warehouse: formData.warehouse,
      variety: formData.variety?.trim() || null,
      companyName: formData.companyName?.trim(),
      vehicleType: formData.vehicleType?.trim(),
      stack: formData.stack?.trim() || null,
      cargoType: formData.cargoType || null,

      noOfBags:
        formData.cargoType === "Bulk"
          ? 0
          : Number(formData.noOfBags),

      containerNo: formData.containerNo?.trim(),
      dateIn: formData.dateIn || null,

      firstWt:
        formData.firstWt !== ""
          ? parseFloat(formData.firstWt)
          : null,

      miscellaneous:
        formData.miscellaneous || null,

      dateOut:
        formData.dateOut || null,

      secondWt:
        formData.secondWt !== ""
          ? parseFloat(formData.secondWt)
          : null,

      netWt: net,

      labourContractorName:
        formData.labourContractorName?.trim() || null,

      surveyorName:
        formData.accountType === "2%"
          ? formData.surveyorName?.trim() || null
          : null,

      accountType: formData.accountType,
    };

    // ============================================
    // UPDATE EXISTING RECORD
    // ============================================
    if (id) {
      try {
        const token = sessionStorage.getItem("token");

        const response = await fetch(
          `https://irc.zentelex.com/api/kataslip/${id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(entry),
          },
        );

        const data = await response.json();

        if (!response.ok || !data.success) {
          throw new Error(
            data.message || "Kata Slip update failed",
          );
        }

        toast.success("Kata Slip updated successfully!", {
          autoClose: 1500,
        });

        setTimeout(() => {
          navigate("/superadmin/updatedata");
        }, 1500);

        return;
      } catch (error) {
        console.error(
          "Kata Slip update error:",
          error,
        );

        toast.error(
          error.message || "Failed to update Kata Slip",
          {
            autoClose: 2500,
          },
        );

        return;
      }
    }

    // ============================================
    // ORIGINAL CREATE FLOW
    // ============================================
    if (editIndex !== null) {
      setEntries((prev) =>
        prev.map((item, index) =>
          index === editIndex ? entry : item,
        ),
      );

      setEditIndex(null);

      toast.success("Entry updated!", {
        autoClose: 1000,
      });
    } else {
      setEntries((prev) => [...prev, entry]);

      setTruckNos((prev) =>
        prev.filter(
          (truck) => truck !== formData.vehicleNo,
        ),
      );

      toast.success("Added to list", {
        autoClose: 1000,
      });
    }

    setFormData({
      vehicleNo: formData.vehicleNo,
      product: formData.product,
      companyName: formData.companyName,
      variety: formData.variety || "",
      cargoType: formData.cargoType || "",
      vehicleType: "",
      stack: "",
      noOfBags: "",
      miscellaneous: "",
      containerNo: "",
      dateIn: sessionDate,
      dateOut: "",
      firstWt: "",
      secondWt: "",
      netWt: "",
      warehouse: formData.warehouse,
      labourContractorName:
        formData.labourContractorName || "",
      surveyorName: "",
      accountType: formData.accountType,
    });
  };

  const submitAllEntries = async () => {
    // Existing records are saved directly by handleSubmit()
    // when editing with /kataslip/:id.
    if (id) {
      return;
    }

    try {
      const token = sessionStorage.getItem("token");

      const response = await fetch(
        "https://irc.zentelex.com/api/kataslip",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ entries }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Bulk submission failed",
        );
      }

      toast.success(
        "All Kata Slips submitted successfully!",
        {
          autoClose: 1500,
        },
      );

      setEntries([]);

      navigate("/commodity-received-document");
    } catch (error) {
      console.error(
        "Kata Slip submission error:",
        error,
      );

      toast.error(
        error.message || "Something went wrong",
      );
    }
  };

  return (
    <>
      <Layout>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <h4 className="page-title">
                      {id
                        ? "Update Kata Slip"
                        : "Upload Inbound Kata Slip Data"}
                    </h4>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center mt-4">
                <div className="col-xxl-6 col-lg-8 col-md-10">
                  <div className="card shadow-sm border-0 rounded-3">
                    <div
                      className="card-body p-4"
                      style={{
                        backgroundColor: "#0F71AD",
                        color: "white",
                        borderRadius: "10px",
                      }}
                    >
                      <h2 className="card-title mb-4 text-center fw-semibold">
                        Kata Slip Entry
                      </h2>

                      <form onSubmit={handleSubmit}>
                        {/* Serial No */}

                        {/* Vehicle No & Type */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Vehicle No
                              <RequiredStar />
                            </label>
                            <select
                              id="vehicleNo"
                              value={formData.vehicleNo}
                              onChange={handleChange}
                              className="form-select"
                              required
                              disabled={!truckNos.length}
                            >
                              <option value="">-- Select Truck --</option>
                              {truckNos.map((truck, index) => (
                                <option key={index} value={truck}>
                                  {truck}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Vehicle Type
                              <RequiredStar />
                            </label>
                            <select
                              id="vehicleType"
                              name="vehicleType"
                              value={formData.vehicleType}
                              onChange={handleChange}
                              className="form-select"
                              required
                            >
                              <option value="">Select Vehicle Type</option>
                              {vehicleTypes.map((type) => (
                                <option key={type} value={type}>
                                  {type}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {/* Product & Company */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Product/Commodity
                              <RequiredStar />
                            </label>
                            <input
                              type="text"
                              id="product"
                              value={formData.product}
                              onChange={handleChange}
                              className="form-control"
                              readOnly
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Company Name
                              <RequiredStar />
                            </label>
                            <input
                              type="text"
                              id="companyName"
                              value={formData.companyName}
                              onChange={handleChange}
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div>

                        {/* Contractor & Surveyor */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Labour Contractor Name
                              <RequiredStar />
                            </label>
                            <input
                              type="text"
                              id="labourContractorName"
                              value={formData.labourContractorName}
                              onChange={handleChange}
                              className="form-control"
                              readOnly
                            />
                          </div>

                          {formData.accountType === "2%" && (
                            <div className="col-md-6 mb-3">
                              <label className="form-label fw-semibold">
                                Surveyor Name
                                <RequiredStar />
                              </label>
                              <input
                                type="text"
                                id="surveyorName"
                                value={formData.surveyorName}
                                onChange={handleChange}
                                className="form-control"
                                required
                              />
                            </div>
                          )}

                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Variety
                              <RequiredStar />
                            </label>
                            <input
                              type="text"
                              id="variety"
                              value={formData.variety}
                              onChange={handleChange}
                              className="form-control"
                              placeholder="Enter variety/type"
                              readOnly
                            />
                          </div>
                        </div>

                        {/* Account Type */}
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Account Type
                            <RequiredStar />
                          </label>
                          <select
                            id="accountType"
                            value={formData.accountType}
                            onChange={handleChange}
                            className="form-select"
                          >
                            <option value="own">Own</option>
                            <option value="2%">2%</option>
                          </select>
                        </div>

                        {/* Amount & Bags */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Stack
                            </label>
                            <input
                              type="text"
                              id="stack"
                              value={formData.stack}
                              onChange={handleChange}
                              className="form-control"
                              placeholder="Enter stack quantity"
                              
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Cargo Type
                              <RequiredStar />
                            </label>
                            <input
                              type="text"
                              id="cargoType"
                              value={formData.cargoType}
                              onChange={handleChange}
                              className="form-control"
                              placeholder="Enter stack quantity"
                              readOnly
                            />
                          </div>

                          {orderprocess.cargo_type !== "Bulk" && (
                            <div className="col-md-6 mb-3">
                              <label className="form-label fw-semibold">
                                No. of Bags
                                <RequiredStar />
                              </label>
                              <input
                                type="number"
                                id="noOfBags"
                                value={formData.noOfBags}
                                onChange={handleChange}
                                className="form-control"
                              />
                            </div>
                          )}

                          {/* Container Number */}
                          <div className="mb-3">
                            <label className="form-label fw-semibold">
                              Container No
                              <RequiredStar />
	                    </label>
                            <input
                              type="text"
                              id="containerNo"
                              value={formData.containerNo}
                              onChange={handleChange}
                              className="form-control"
                              placeholder="Enter container number"
                            />
                          </div>
                        </div>

                        {/* Miscellaneous */}
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Miscellaneous
                          </label>
                          <input
                            type="text"
                            id="miscellaneous"
                            value={formData.miscellaneous}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Enter any additional info"
                          />
                        </div>

                        {/* Dates & Weights */}
                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label className="form-label fw-semibold">
                              Date In
                              <RequiredStar />
                            </label>
                            <input
                              type="date"
                              id="dateIn"
                              value={formData.dateIn}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>

                          <div className="col-md-4 mb-3">
                            <label className="form-label fw-semibold">
                              First Wt
                              <RequiredStar />
                            </label>
                            <input
                              type="number"
                              id="firstWt"
                              value={formData.firstWt}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>

                          <div className="col-md-4 mb-3">
                            <label className="form-label fw-semibold">
                              Warehouse
                              <RequiredStar />
                            </label>
                            <input
                              type="text"
                              id="warehouse"
                              value={formData.warehouse}
                              onChange={handleChange}
                              className="form-control"
	                      readOnly
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Second Wt
                              <RequiredStar />
                            </label>
                            <input
                              type="number"
                              id="secondWt"
                              value={formData.secondWt}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Net Wt
                              <RequiredStar />
                            </label>
                            <input
                              type="number"
                              id="netWt"
                              value={formData.netWt}
                              className="form-control"
                              readOnly // ✅ read-only, auto-calculated
                            />
                          </div>
                        </div>

                        <button className="btn btn-warning w-100">
                          {id ? "Update Kata Slip" : "Submit"}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                {entries.length > 0 && (
                  <div className="card mt-4">
                    <div className="card-body">
                      <h5 className="mb-3">Added Kata Slips</h5>

                      {/* Scrollable wrapper */}
                      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                        <table className="table table-bordered table-sm">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Vehicle No</th>
                              <th>Vehicle Type</th>
                              <th>Product</th>
                              <th>Variety</th>
                              <th>Company</th>
                              <th>Stack</th>
                              <th>No. of Bags</th>
                              <th>Container No</th>
                              <th>Date In</th>
                              <th>First Wt</th>
                              <th>Second Wt</th>
                              <th>Net Wt</th>
                              <th>Labour Contractor</th>
                              <th>Surveyor</th>
                              <th>Account Type</th>
                              <th>Miscellaneous</th>
                              <th>Cargo Type</th>

                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {entries.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.vehicleNo}</td>
                                <td>{item.vehicleType}</td>
                                <td>{item.product}</td>
                                <td>{item.variety || "-"}</td>
                                <td>{item.companyName}</td>
                                <td>{item.stack || "-"}</td>
                                <td>{item.noOfBags || "-"}</td>
                                <td>{item.containerNo}</td>
                                <td>{item.dateIn}</td>
                                <td>{item.firstWt || "-"}</td>
                                <td>{item.secondWt || "-"}</td>
                                <td>{item.netWt || "-"}</td>
                                <td>{item.labourContractorName || "-"}</td>
                                <td>{item.surveyorName || "-"}</td>
                                <td>{item.accountType}</td>
                                <td>{item.miscellaneous || "-"}</td>

                                <td>{item.cargoType || "-"}</td>

                                <td>
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => {
                                      setFormData({ ...item });
                                      setEditIndex(index);
                                    }}
                                  >
                                    Edit
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                <button
                  className="btn btn-success w-100 mt-3"
                  onClick={submitAllEntries}
                  disabled={entries.length === 0}
                >
                  Submit All ({entries.length})
                </button>
              </div>

              <ToastContainer />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
